import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./TutorialVideoStyle.module.css";
import videoData from "./videodata.json";
import { deviceCheck } from "../../Values/utils";

type props = {};

const TutorialVideo: FunctionComponent<props> = ({ }) => {
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [activeIndex, setActiveIndex] = useState<number | null>(0);

    const toggleAccordion = (event:any, index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
        setTimeout(()=>{
            event.target.scrollIntoView(true);
        }, 50);
    };    

    return (
        <div className={styles.TutorialVideo}>
            {deviceCheck() && <div className={styles.HelpSupportTabText}>
                Illustrative tutorial videos for different  tasks in read pro
            </div>}
            {videoData.map((item, index) => {
                return (
                    <div className={styles.TutorialVideoWrap} key={index}>
                        <div className={styles.TutorialVideoHeading} onClick={(event)=>toggleAccordion(event, index)}>
                            {item.heading}
                            <span className={`faq__block__arrow ${activeIndex === index?'rotate':''}`}></span>
                        </div>

                        {activeIndex === index && (
                            <div className={styles.TutorialVideoList}>
                                {item.list.map((data, intex) => {
                                    
                                    return (
                                        <div className={styles.TutorialVideoCard} onClick={() => setVideoUrl(data.videoPath)}>
                                            <div className={styles.TutorialVideoCardThumb}>
                                                <div className={styles.TutorialVideoCardTitle}>{data.title}</div>
                                                <div className={styles.TutorialVideoCardVideoIcon}></div>
                                            </div>
                                            <div className={styles.TutorialVideoCardInfo}>
                                                <div className={styles.TutorialVideoCardInfoLabel}>
                                                    Duration: <span>{data.duration}</span>
                                                </div>
                                                <div className={styles.TutorialVideoCardInfoLabel}>
                                                    Updated: {data.updatedDate}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                )
            })}

            {videoUrl &&
                <div className={styles.TutorialVideoPopup}>
                    <div className={styles.TutorialVideoPopupContent}>
                        <div className={styles.TutorialVideoPopupClose} onClick={() => setVideoUrl(null)}></div>

                        <video width="100%" height="100%" autoPlay controls>
                            <source src={videoUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            }
        </div>
    );
};

export default TutorialVideo;